import React from 'react';
import { useTranslation } from 'react-i18next';

function Education() {
  const { t } = useTranslation();

  return (
    <section className="education-section" id="education">
      <h3>{t('education.title')}</h3>
      
      <div className="education-item">
        <div className="education-header">
          <h4>{t('education.licence3.title')}</h4>
          <span className="institution">{t('education.licence3.institution')}</span>
          <span className="period">{t('education.licence3.period')}</span>
        </div>
        <p>{t('education.licence3.description')}</p>
      </div>
      
      <div className="education-item">
        <div className="education-header">
          <h4>{t('education.bac.title')}</h4>
          <span className="institution">{t('education.bac.institution')}</span>
          <span className="period">{t('education.bac.period')}</span>
        </div>
        <p>{t('education.bac.description')}</p>
      </div>

      <div className="education-item certifications-block" style={{ marginTop: '28px' }}>
        <h4 style={{ color: '#0d9488', fontSize: '1.1rem', marginBottom: '12px' }}>{t('certifications.title')}</h4>
        <ul style={{ listStyleType: 'none', paddingLeft: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <li style={{ padding: '6px 12px', background: 'rgba(13, 148, 136, 0.08)', borderRadius: '6px', fontSize: '0.95rem' }}>
            🎓 <strong>UC Davis (Coursera) :</strong> {t('certifications.ucdavis_vector')}
          </li>
          <li style={{ padding: '6px 12px', background: 'rgba(13, 148, 136, 0.08)', borderRadius: '6px', fontSize: '0.95rem' }}>
            🎓 <strong>UC Davis (Coursera) :</strong> {t('certifications.ucdavis_arcgis')}
          </li>
          <li style={{ padding: '6px 12px', background: 'rgba(13, 148, 136, 0.08)', borderRadius: '6px', fontSize: '0.95rem' }}>
            ☁️ <strong>AWS (Coursera) :</strong> {t('certifications.aws')}
          </li>
          <li style={{ padding: '6px 12px', background: 'rgba(13, 148, 136, 0.08)', borderRadius: '6px', fontSize: '0.95rem' }}>
            📡 <strong>UC Irvine (Coursera) :</strong> {t('certifications.iot')}
          </li>
          <li style={{ padding: '6px 12px', background: 'rgba(13, 148, 136, 0.04)', borderRadius: '6px', fontSize: '0.95rem' }}>
            🌐 {t('certifications.web')}
          </li>
          <li style={{ padding: '6px 12px', background: 'rgba(13, 148, 136, 0.04)', borderRadius: '6px', fontSize: '0.95rem' }}>
            🛸 {t('certifications.agisoft')}
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Education; 